import { Card, CardBody, Table } from "reactstrap";
import { useWorkOrderOverview } from "../WorkOrderOverviewContext";
import { formatCurrency } from "utils/currency";

export default function Expenses() {
  const { workOrder } = useWorkOrderOverview();

  if (!workOrder) return null;

  const expenses = workOrder.expenses ?? [];
  const total = expenses.reduce((sum, e) => sum + Number(e.amount ?? 0), 0);

  return (
    <Card>
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h6 className="text-uppercase mb-0">Direct Expenses</h6>
          {expenses.length > 0 && (
            <span className="text-muted small">
              Total:{" "}
              <span className="fw-semibold text-body">
                {formatCurrency(total)}
              </span>
            </span>
          )}
        </div>

        {expenses.length === 0 ? (
          <p className="text-muted mb-0">
            No expenses recorded for this work order.
          </p>
        ) : (
          <div className="table-responsive table-card">
            <Table className="table-borderless align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Category</th>
                  <th>Description</th>
                  <th className="text-end">Amount</th>
                </tr>
              </thead>
              <tbody>
                {expenses.map((exp, idx) => (
                  <tr key={exp.id ?? idx}>
                    <td className="text-muted">{idx + 1}</td>
                    <td className="fw-medium">
                      {exp.category?.name ??
                        `Category #${exp.expenseCategoryId}`}
                    </td>
                    <td className="text-muted small">
                      {exp.description?.trim() || "—"}
                    </td>
                    <td className="text-end fw-semibold tabular-nums">
                      {formatCurrency(exp.amount)}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-light">
                <tr>
                  <td colSpan={3} className="text-end fw-semibold small text-muted">
                    Total
                  </td>
                  <td className="text-end fw-bold tabular-nums">
                    {formatCurrency(total)}
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
}
